import { cloneDeep, get, isArray, pull, update } from "lodash";

export function setWithArrayPush(state, path, item) {
  return update(cloneDeep(state), path, (array = []) => {
    if (!isArray(array)) throw new Error("Not an array");
    array.push(item);
    return array;
  });
}

export function setWithArrayPull(state, path, item) {
  return update(cloneDeep(state), path, (array = []) => {
    if (!isArray(array)) throw new Error("Not an array");
    pull(array, item);
    return array;
  });
}

export function getStateWithStringPath(state, path) {
  return get(state, path.split("."));
}

export function stateModified(name, value, initState, state, modifiedFlag) {
  const initStateValue = initState[name];
  if (initStateValue !== value) state[modifiedFlag] = true;
  else state[modifiedFlag] = false;
}
